import { render } from "./OurMethod.vue?vue&type=template&id=3847b0e2&scoped=true"
import script from "./OurMethod.vue?vue&type=script&lang=js"
export * from "./OurMethod.vue?vue&type=script&lang=js"

import "./OurMethod.vue?vue&type=style&index=0&id=3847b0e2&lang=less&scoped=true"
import "./OurMethod.vue?vue&type=style&index=1&id=3847b0e2&lang=less&scoped=true"
import "./OurMethod.vue?vue&type=style&index=2&id=3847b0e2&lang=less&scoped=true"
import "./OurMethod.vue?vue&type=style&index=3&id=3847b0e2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3847b0e2"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader});
